
import React, { PureComponent } from 'react';
import * as moment from 'moment'
import { connect } from 'react-redux';
import {
	Redirect,
} from 'react-router-dom';
import { withRouter } from "react-router";

import CONSTANTS from '../../constants';
import BodyClassName from 'react-body-classname'
import LayoutStandardWidth from "../../layouts/LayoutStandardWidth";
import SummarySectionBlock from "./summarySectionBlock";
import { TextArea, Button } from "../Forms/Forms";
import fetchApiData from '../apiHandlers/fetchApiData'
import {
	setServices, CurrentStepSetAction, setCodePasForAnnualService, setCustomerAttachmentId,
	setPersonalInformations, setVeiculeInfos, setUploadFiles,
	setVeiculeKilo, bookingSetAction, selectedServices,
	setCommentServices, dealerSetAction,
	setEditMode, setDateLimitModif, setSelectedPremiumServicesToStore
} from '../../actions/action';
import DealerSummary from './sections/dealerSummary'
import CarSummary from './sections/carSummary'
import PersonalInfosSummary from './sections/personalInfosSummary'
import OperationsSummary from './sections/operationsSummary'
import ContentLoader from 'react-content-loader'
import { headTitleTag, isThisPrestationHasForfait } from '../../helpers/functions';
import { pushToGTMTracker, pushEventToGTM } from '../../helpers/trackerManager';

import "./summaryPage.css";
import DealerSummaryFlex from './sectionsCitroen/dealerSummaryFlex';
import CarSummaryFlex from './sectionsCitroen/carSummaryFlex';
import PersonalInfosSummaryFlex from './sectionsCitroen/personalInfosSummaryFlex';
import OperationsSummaryFlex from './sectionsCitroen/operationsSummaryFlex';

const mapStateToProps = state => state;
const mapDispatchToProps = {
	setServices, setPersonalInformations, setCodePasForAnnualService, setCustomerAttachmentId,
	setVeiculeInfos, setVeiculeKilo, dealerSetAction, setUploadFiles,
	bookingSetAction, CurrentStepSetAction, selectedServices,
	setCommentServices, setEditMode, setDateLimitModif, setSelectedPremiumServicesToStore
};

class SummaryPage extends PureComponent {
	_isMounted = false;
	static defaultProps = {
		Edit: false,
	};

	constructor(props) {
		super(props);
		this.state = {
			showPlaceHolder: false,
			messageArea: props.store.commentServices,
			showConfirmationPage: false,
			isThereAforfaitWithPrice: false,
			redirectToLocation: false,
			redirectToErrorPage: false,
			expiredDate: false,
			isErrorMessageArea : false
		};
		this.calculateforfaitPrice = this.calculateforfaitPrice.bind(this);
		this.sendDataToServer = this.sendDataToServer.bind(this);
	}
	componentDidUpdate() {
		this.calculateforfaitPrice();
	}
	componentWillMount() {
		this._isMounted = true;
		// Is Edit Mode Activated
		if (!!this.props.Edit) {
			// Verify here if the basket exist or not yet
			// if Yes then fill the store with selected services
			// if NO then redirect to the firstpage
			this.props.setEditMode(this.props.match.params.idBasket);
			this.props.CurrentStepSetAction(6);
			// push to analytics
			pushToGTMTracker("edit-page", window.siteConfig.v2modification.Title.replace('[nom-marque]', CONSTANTS.SITE_INFO.BRAND_NAME.toUpperCase()));
			pushEventToGTM({
				pageName: 'summary',
				eventAction: 'Click::CTA',
				eventLabel: 'summary_modify_appointment'
			});
			this.setState({ showPlaceHolder: true });
			const API = new fetchApiData();
			console.error(API);
			API.getClientBasket({
				'basketId': Number(this.props.match.params.idBasket),
				'keyModif': this.props.match.params.token

			}).then(
				data => {
					if (data.d.error === 0 && data.d.personalInfos != null) {
						let attachments = []
						if (data.d.attachments.length > 0) {
							for (let index = 0; index < data.d.attachments.length; index++) {
								attachments.push({ attachmentUrl: data.d.attachments[index].attachmentUrl, path: data.d.attachments[index].fileName });
							}
						}
						this.props.setCodePasForAnnualService(data.d.codePas)
						this.props.selectedServices(data.d.SelectedServices);
						this.props.setSelectedPremiumServicesToStore(data.d.ServicePremium)
						this.props.setCommentServices(data.d.commentServices);
						this.props.setUploadFiles(attachments)
						this.props.setCustomerAttachmentId(data.d.attachmentId)
						this.setState({ messageArea: this.props.store.commentServices });
						this.props.dealerSetAction(data.d.dealer);
						this.props.bookingSetAction(data.d.booking);
						this.props.setVeiculeInfos(data.d.car);
						this.props.setVeiculeKilo(data.d.kilo);
						this.props.setPersonalInformations(data.d.personalInfos);
						this.setState({ showPlaceHolder: false });
						this.props.setDateLimitModif(data.d.DateLimite);
						this.calculateDateLimite(this.props.store.dateLimitModif);


					} else {
						this.setState({ redirectToErrorPage: true });
					}
				})
				.catch(error => {
					console.log('Eror: ', error);
					this.setState({ redirectToErrorPage: true });
					this.setState({ showPlaceHolder: false });
				});
		} else {
			pushToGTMTracker("summary-page", window.siteConfig.v2recapitulatif.Title.replace('[nom-marque]', CONSTANTS.SITE_INFO.BRAND_NAME.toUpperCase()));
		}
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		this.calculateforfaitPrice();
	}

	calculateDateLimite = (dateLimit) => {
		var limit = moment(dateLimit).format('YYYY/MM/DD');
		var now = moment().format('YYYY/MM/DD');
		if (now < limit) {
			this.setState({ expiredDate: false });
		} else {
			this.setState({ expiredDate: true });
		}
	}


	sendDataToServer() {
		this.setState({ showPlaceHolder: true });
		const selectedServicesCodes = [];
		const selectedFamiliesCodes = []
		this.props.store.SelectedServices.forEach((fforfait, ffkey) => {
			fforfait.forfaits != null && !!Object.values(fforfait.forfaits) &&
				Object.values(fforfait.forfaits).forEach((forfait, fkey) => {

					!!Object.values(forfait.SubFunctionList).length &&
						forfait.SubFunctionList[0].ForfaitList.forEach((forfaitItem, fikey) => {

							if (forfaitItem.isSelected) {
								selectedServicesCodes.push(forfaitItem.Items[0].Ref);
								selectedFamiliesCodes.push(forfait.Code);
							}
							forfaitItem.Operations && forfaitItem.Operations.forEach((operation, OpKey) => {
								if (operation.isSelected) {
									selectedServicesCodes.push(operation.Items[0].Ref);
									selectedFamiliesCodes.push(forfait.Code);
								}
							});
						});
				});
		});
		const API = new fetchApiData();
		if (this.props.store)
			console.log(this.props.store)
		const listeInterventions = [];
		this.props.store.SelectedServices.map(function (item, key) {			
			if (!isThisPrestationHasForfait(item)) {
				listeInterventions.push({ "InterventionId": item.interventionId, "interventionLabel": item.interventionLabel });
			}

		});


		API.confirmeRDVBasket({
			"carDetails": { ...this.props.store.booking, ...this.props.store.car, ...this.props.store.kilo },
			"personalInfos": { ...this.props.store.personalInfos },
			"dealerInfos": { ...this.props.store.dealer },
			"selectedServices": {
				comment: this.props.store.commentServices,
				"subFunctionCodes": { ...selectedFamiliesCodes },
				"forfaitRefs": { ...selectedServicesCodes },
			},
			"listeServicePremium": [...this.props.store.selectedPremiumServices],
			"listeInterventions": listeInterventions,
			"idRdv": Number(this.props.store.isEditMode),
			"AttachmentID": this.props.store.customerAttachmentId ? this.props.store.customerAttachmentId : "",
		}, this.props.store.codePasForAnnualService, this.props.store.idRdvLeads).then(
			data => {
				if (this._isMounted) {
					console.log(data);
					if (data.d.ErrorCode === 0) {
						sessionStorage.setItem('dy_quality_observer', data.d.Summary)
						this.setState({ redirectToLocation: true });
					} else {
						this.setState({ redirectToErrorPage: true });
						this.setState({ showPlaceHolder: false });
					}
				}
			})
			.catch(error => {
				console.log('Error: ', error);
				this.setState({ redirectToErrorPage: true });
				this.setState({ showPlaceHolder: false });
			});
	}
	calculateforfaitPrice() {
		let price = 0;
		this.props.store.SelectedServices.forEach((fforfait, ffkey) => {

			fforfait.forfaits != null && !!Object.values(fforfait.forfaits) &&
				Object.values(fforfait.forfaits).forEach((forfait, fkey) => {

					!!Object.values(forfait.SubFunctionList).length &&
						forfait.SubFunctionList[0].ForfaitList.forEach((forfaitItem, fikey) => {

							if (forfaitItem.isSelected) {
								price += forfaitItem.Items[0].Prix;
							}
							forfaitItem.Operations && forfaitItem.Operations.forEach((operation, OpKey) => {
								if (operation.isSelected) {
									price += operation.Items[0].Prix;
								}
							});
						});
				});
		});
		this.setState({ isThereAforfaitWithPrice: (price > 0) });
	}


	componentWillUnmount() {
		this._isMounted = false;
	}

	CommentarySectionCitroen = () =>(
		<div className="rootCommentContainer">
			<div className="commentSectionTitle">
				{`${CONSTANTS.LABELS.summary_comment} ( ${this.state.messageArea.length}/500 ${CONSTANTS.LABELS.summary_comment_label1} )`}
			</div>
			<TextArea
				onChange={(e) => {
				if (
					e.target.value.match(
					/[^\p{L}\p{N}\p{M}\p{Sc}\s\.\?%!:,¿¡'"-]/gu
					)
				) {
					this.setState({ isErrorMessageArea: true });
				} else if (e.target.value.length <= 500) {
					this.setState({
					messageArea: e.target.value,
					isErrorMessageArea: false,
					});
					this.props.setCommentServices(e.target.value);
				}
				}}
				maxLength={500}
				value={this.state.messageArea}
				autoComplete={"on"}
				aria-label={CONSTANTS.LABELS.summary_comment}
				iserror={this.state.isErrorMessageArea}
				labelerror={
				CONSTANTS.LABELS.userinfos_error_name_special_char
				}
				cols={"unset"}
				rows={"unset"}
				className="commentTextArea"
			></TextArea>
		</div>
	)
	render() {
		const SEO_TITLE = (this.props.isEditMode ? (window.siteConfig.v2modification != undefined ? window.siteConfig.v2modification.Title : '')
			: (window.siteConfig.v2recapitulatif != undefined ? window.siteConfig.v2recapitulatif.Title : ''));
		const SEO_DESC = (this.props.isEditMode ? (window.siteConfig.v2modification != undefined ? window.siteConfig.v2modification.MetaDescription : '')
			: (window.siteConfig.v2recapitulatif != undefined ? window.siteConfig.v2recapitulatif.MetaDescription : ''));
		const expiredDateStyle = {
			textAlign: "center",
			color: "red",
			paddingTop: "20px",
			fontSize: "20px"
		};
		if (!this.state.showPlaceHolder)
			return (
        <React.Fragment>
          {headTitleTag(
            SEO_TITLE.replace(
              "[nom-marque]",
              CONSTANTS.SITE_INFO.BRAND_NAME.toUpperCase()
            ),
            SEO_DESC.replace(
              "[nom-marque]",
              CONSTANTS.SITE_INFO.BRAND_NAME.toUpperCase()
            )
          )}
          {CONSTANTS.SITE_INFO.BRAND_CODE !== "C" && (
            <div className="full-page page-summary">
              <BodyClassName className="page-summary" />
              <h3 tabIndex="0" className="page-title">
                {CONSTANTS.LABELS.summary_title}
                {this.props.store.isEditMode && this.state.expiredDate && (
                  <p style={expiredDateStyle}>
                    {CONSTANTS.LABELS.summary_warning_noedit}
                  </p>
                )}
              </h3>
              <LayoutStandardWidth classes="container-specific-width">
                <div className="toLeft">
                  <DealerSummary
                    isWithPrice={this.state.isThereAforfaitWithPrice}
                    expiredDate={this.state.expiredDate}
                  />
                  <CarSummary
                    isWithPrice={this.state.isThereAforfaitWithPrice}
                    expiredDate={this.state.expiredDate}
                  />
                  <PersonalInfosSummary
                    opened={false}
                    expiredDate={this.state.expiredDate}
                  />
                  {window.isMobile() == "desktop" && (
                    <SummarySectionBlock
                      fold={
                        CONSTANTS.SITE_INFO.BRAND_CODE === "D" ? true : false
                      }
                      opened={
                        CONSTANTS.SITE_INFO.BRAND_CODE === "D" ? false : true
                      }
                      className={"text-comment"}
                      title={CONSTANTS.LABELS.summary_comment}
                      description={`(${this.state.messageArea.length}/500 ${CONSTANTS.LABELS.summary_comment_label1})`}
                    >
                      <TextArea
                        onChange={(e) => {
                          if (
                            e.target.value.match(
                              /[^\p{L}\p{N}\p{M}\p{Sc}\s\.\?%!:,¿¡'"-]/gu
                            )
                          ) {
                            this.setState({ isErrorMessageArea: true });
                          } else {
                            this.setState({
                              messageArea: e.target.value,
                              isErrorMessageArea: false,
                            });
                            this.props.setCommentServices(e.target.value);
                          }
                        }}
                        maxLength={500}
                        value={this.state.messageArea}
                        iserror={this.state.isErrorMessageArea}
                        labelerror={
                          CONSTANTS.LABELS.userinfos_error_name_special_char
                        }
                        cols="80"
                      ></TextArea>
                    </SummarySectionBlock>
                  )}
                </div>
                <div className="toRight">
                  <OperationsSummary expiredDate={this.state.expiredDate} />
                </div>
                {window.isMobile() !== "desktop" && (
                  <SummarySectionBlock
                    fold={false}
                    opened={true}
                    className={"text-comment"}
                    title={CONSTANTS.LABELS.summary_comment}
                    description={`(${this.state.messageArea.length}/500 ${CONSTANTS.LABELS.summary_comment_label1})`}
                  >
                    <TextArea
                      onChange={(e) => {
                        if (
                          e.target.value.match(
                            /[^\p{L}\p{N}\p{M}\p{Sc}\s\.\?%!:,¿¡'"-]/gu
                          )
                        ) {
                          this.setState({ isErrorMessageArea: true });
                        } else if (e.target.value.length <= 500) {
                          this.setState({
                            messageArea: e.target.value,
                            isErrorMessageArea: false,
                          });
                          this.props.setCommentServices(e.target.value);
                        }
                      }}
                      maxLength={500}
                      value={this.state.messageArea}
                      autoComplete={"on"}
                      aria-label={CONSTANTS.LABELS.summary_comment}
                      iserror={this.state.isErrorMessageArea}
                      labelerror={
                        CONSTANTS.LABELS.userinfos_error_name_special_char
                      }
                      cols="80"
                    ></TextArea>
                  </SummarySectionBlock>
                )}
              </LayoutStandardWidth>
              {!this.state.expiredDate && (
                <div className="sticky-button">
                  <LayoutStandardWidth classes="container-specific-width">
                    {this.props.store.isEditMode && (
                      <Button
                        Disabled={this.props.store.SelectedServices.length < 1}
                        //linkTo={CONSTANTS.SITE_ROUTS.CONFIRMATION}
                        onClick={(e) => {
                          this.sendDataToServer();
                        }}
                      >
                        {CONSTANTS.LABELS.summary_modifyrdv}
                      </Button>
                    )}

                    {!this.props.store.isEditMode && (
                      <Button
                        Disabled={this.props.store.SelectedServices.length < 1}
                        //linkTo={CONSTANTS.SITE_ROUTS.CONFIRMATION}
                        onClick={(e) => {
                          this.sendDataToServer();
                        }}
                      >
                        {CONSTANTS.LABELS.summary_confirmrdv}
                      </Button>
                    )}
                  </LayoutStandardWidth>
                </div>
              )}
            </div>
          )}

          {CONSTANTS.SITE_INFO.BRAND_CODE === "C" && (
            <div className="rootCitroenSummaryContainer">
              <div tabIndex="0" className="summaryTitle">
                {CONSTANTS.LABELS.summary_title}
              </div>

              {this.props.store.isEditMode && this.state.expiredDate && (
                <div className="summaryTitleNoEdit">
                  {CONSTANTS.LABELS.summary_warning_noedit}
                </div>
              )}

              <div className="columnsContainer">
                <div className="leftColumn">
                  <DealerSummaryFlex
                    isWithPrice={this.state.isThereAforfaitWithPrice}
                    expiredDate={this.state.expiredDate}
                  />
                  <CarSummaryFlex
                    isWithPrice={this.state.isThereAforfaitWithPrice}
                    expiredDate={this.state.expiredDate}
                  />
                  <PersonalInfosSummaryFlex
                    opened={false}
                    expiredDate={this.state.expiredDate}
                  />
                  <this.CommentarySectionCitroen />
                </div>
                <div className="rightColumn">
                  <OperationsSummaryFlex expiredDate={this.state.expiredDate} />
                </div>
              </div>

              {!this.state.expiredDate && (
                <div className="stickyButtonContainer">
                  {(this.props.store.isEditMode ||
                    !this.props.store.isEditMode) && (
                    <Button
                      Disabled={this.props.store.SelectedServices.length < 1}
                      onClick={(e) => {
                        this.sendDataToServer();
                      }}
                    >
                      {this.props.store.isEditMode
                        ? CONSTANTS.LABELS.summary_modifyrdv
                        : CONSTANTS.LABELS.summary_confirmrdv}
                    </Button>
                  )}
                </div>
              )}
            </div>
          )}
        </React.Fragment>
      );
		else
			return (<div>
				<ContentLoader preserveAspectRatio="none" >
					<rect x="215" y="30" width="140" height="10"></rect>
					<rect x="215" y="42" width="140" height="30"></rect>
					<rect x="65" y="60" width="140" height="10"></rect>
					<rect x="65" y="75" width="140" height="5"></rect>
					<rect x="70%" y="85" width="50" height="10"></rect>
					<rect x="150" y="10" width="100" height="5"></rect>
					<rect x="150" y="18" width="100" height="3"></rect>
				</ContentLoader>

				{this.state.redirectToLocation && <Redirect
					to={{ pathname: `${CONSTANTS.SITE_ROUTS.CONFIRMATION}` }}
				/>
				}
				{this.state.redirectToErrorPage && <Redirect
					to={{ pathname: '/404' }}
				/>
				}
			</div>
			);

	}
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SummaryPage));
